import * as pathToRegexp from 'path-to-regexp';
import { App } from '@app/src/views';
import { StepOne } from '@app/src/views/StepOne';
import { StepTwo } from '@app/src/views/StepTwo';
import { StepThree } from '@app/src/views/StepThree';
import { StepPayment } from '@app/src/views/StepPayment';
import { NotFound } from '@app/src/views/NotFound';
import { withStep } from '@app/src/common/withStep';
import { Home } from '@app/src/views/Home';
import { Agency } from '@app/src/views/Agency';
import { PaymentConfirm } from '@app/src/views/PaymentConfirm';
import { PaymentPending } from '@app/src/views/PaymentPending';
import { CATEGORY_ALIAS, CATEGORIES } from '@app/src/config/categories';

const pathProperty = CATEGORIES[CATEGORY_ALIAS.INMUEBLE].link;
const pathEmployment = CATEGORIES[CATEGORY_ALIAS.EMPLEO].link;
const pathOpportunity = CATEGORIES[CATEGORY_ALIAS.OPORTUNIDAD].link;
const pathVehicle = CATEGORIES[CATEGORY_ALIAS.VEHICULO].link;
const pathEducation = CATEGORIES[CATEGORY_ALIAS.EDUCACION].link;

export const Routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        component: Home,
        exact: true,
        alias: 'home'
      },
      {
        path: '/agencias',
        component: Agency,
        exact: true,
        alias: 'agency'
      },
      {
        path: `${pathProperty}-1`,
        component: withStep(StepOne, { step: 1, alias: CATEGORY_ALIAS.INMUEBLE}),
        exact: true,
        alias: 'stepOne'
      },
      {
        path: `${pathProperty}-2`,
        component: withStep(StepTwo, { step: 2, alias: CATEGORY_ALIAS.INMUEBLE}),
        exact: true,
        alias: 'stepTwo'
      },
      {
        path: `${pathProperty}-3/:idPrint?`,
        component: withStep(StepThree, { step: 3, alias: CATEGORY_ALIAS.INMUEBLE}),
        exact: true,
        alias: 'stepThree'
      },
      {
        path: `${pathProperty}-4/:id?`,
        component: withStep(StepPayment, { step: 4, alias: CATEGORY_ALIAS.INMUEBLE}),
        exact: true,
        alias: 'stepPayment'
      },
      {
        path: '/confirmacion-de-pago',
        component: withStep(PaymentConfirm),
        exact: true,
        alias: 'paymentConfirm'
      },
      {
        path: '/pendiente-de-pago',
        component: withStep(PaymentPending),
        exact: true,
        alias: 'paymentPending'
      },
      {
        path: `${pathEmployment}-1`,
        component: withStep(StepOne, { step: 1, alias: CATEGORY_ALIAS.EMPLEO}),
        exact: true,
        alias: 'stepOneJob'
      },
      {
        path: `${pathEmployment}-2`,
        component: withStep(StepTwo, { step: 2, alias: CATEGORY_ALIAS.EMPLEO}),
        exact: true,
        alias: 'stepTwoJob'
      },
      {
        path: `${pathEmployment}-3/:idPrint?`,
        component: withStep(StepThree, { step: 3, alias: CATEGORY_ALIAS.EMPLEO}),
        exact: true,
        alias: 'stepThreeJob'
      },
      {
        path: `${pathEmployment}-4/:id?`,
        component: withStep(StepPayment, { step: 4, alias: CATEGORY_ALIAS.EMPLEO}),
        exact: true,
        alias: 'stepPaymentJob'
      },
      {
        path: `${pathOpportunity}-1`,
        component: withStep(StepOne, { step: 1, alias: CATEGORY_ALIAS.OPORTUNIDAD}),
        exact: true,
        alias: 'stepOneOpportunity'
      },
      {
        path: `${pathOpportunity}-2`,
        component: withStep(StepTwo, { step: 2, alias: CATEGORY_ALIAS.OPORTUNIDAD}),
        exact: true,
        alias: 'stepTwoOpportunity'
      },
      {
        path: `${pathOpportunity}-3/:idPrint?`,
        component: withStep(StepThree, { step: 3, alias: CATEGORY_ALIAS.OPORTUNIDAD}),
        exact: true,
        alias: 'stepThreeOpportunity'
      },
      {
        path: `${pathOpportunity}-4/:id?`,
        component: withStep(StepPayment, { step: 4, alias: CATEGORY_ALIAS.OPORTUNIDAD}),
        exact: true,
        alias: 'stepPaymentOpportunity'
      },
      {
        path: `${pathVehicle}-1`,
        component: withStep(StepOne, { step: 1, alias: CATEGORY_ALIAS.VEHICULO}),
        exact: true,
        alias: 'stepOneVehicle'
      },
      {
        path: `${pathVehicle}-2`,
        component: withStep(StepTwo, { step: 2, alias: CATEGORY_ALIAS.VEHICULO}),
        exact: true,
        alias: 'stepTwoVehicle'
      },
      {
        path: `${pathVehicle}-3/:idPrint?`,
        component: withStep(StepThree, { step: 3, alias: CATEGORY_ALIAS.VEHICULO}),
        exact: true,
        alias: 'stepThreeVehicle'
      },
      {
        path: `${pathVehicle}-4/:id?`,
        component: withStep(StepPayment, { step: 4, alias: CATEGORY_ALIAS.VEHICULO}),
        exact: true,
        alias: 'stepPaymentVehicle'
      },
      {
        path: `${pathEducation}-1`,
        component: withStep(StepOne, { step: 1, alias: CATEGORY_ALIAS.EDUCACION}),
        exact: true,
        alias: 'stepOneEducation'
      },
      {
        path: `${pathEducation}-2`,
        component: withStep(StepTwo, { step: 2, alias: CATEGORY_ALIAS.EDUCACION}),
        exact: true,
        alias: 'stepTwoEducation'
      },
      {
        path: `${pathEducation}-3/:idPrint?`,
        component: withStep(StepThree, { step: 3, alias: CATEGORY_ALIAS.EDUCACION}),
        exact: true,
        alias: 'stepThreeEducation'
      },
      {
        path: `${pathEducation}-4/:id?`,
        component: withStep(StepPayment, { step: 4, alias: CATEGORY_ALIAS.EDUCACION}),
        exact: true,
        alias: 'stepPaymentEducation'
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
];

export const AliasRouter = (alias: string, params: {} = {}): string => {
  let routes = Routes[0].routes;
  for (let k in routes) {
    if (routes[k].alias === alias) {
      let toPath = pathToRegexp.compile(routes[k].path);
      return toPath(params);
    }
  }
  return '';
}
